module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    attrs: {
      "aria-label": "v",
      "id": "pg_v",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("Look, I am living")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('i', [_vm._v("—on what?")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_c('b', [_vm._v("—RAINER MARIA RILKE")]), _vm._v(", "), _c('i', [_vm._v("Duino Elegies")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('i', [_vm._v("I continue to write because I have not yet heard what I have been listening to.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_c('b', [_vm._v("—MARY RUEFLE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 66
// module chunks = 0